<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <section class="section white-panel mb3p">
          <h2 class="fs16 font-weight-bold mt12 mb12">洗車プリペイドとは？</h2>
          <p class="fs14 mb12">カーライフスクエアのお客様だけが使えるおトクなサービスです。</p>
          <p class="fs14 mb12 color-red1">ご利用いただける洗車コースはご利用SSによって、異なる場合がございます。</p>
          <p class="fs14 mb12 color-red1">詳細につきましてはSSに直接お問い合わせください。</p>

          <h2 class="fs14 font-weight-bold mb4 bdb-solid-gray1">洗車コース</h2>
          <table class="table w100p fs12 line-height1_7 mb20">
            <tbody>
              <tr>
                <td class="bdb-solid-gray1 fs14 pt8 pl4 pb8 pr4 w20p va-top"><img src="/lib/images/ic_carwash_1.svg" width="48"></td>
                <td class="bdb-solid-gray1 fs14 pt8 pb8 pr4">
                  <p class="font-weight-bold">水洗い洗車</p>
                  <p>水のみで車体を洗う手軽なメニューです。キーパーやディーラーで車体をコーティングをしている場合にもおすすめです。</p>
                </td>
              </tr>
              <tr>
                <td class="bdb-solid-gray1 fs14 pt8 pl4 pb8 pr4 va-top"><img src="/lib/images/ic_carwash_2.svg" width="48"></td>
                <td class="bdb-solid-gray1 fs14 pt8 pb8 pr4">
                  <p class="font-weight-bold">シャンプー洗車</p>
                  <p>シャンプー（洗剤）を使い洗車することで、より強力に汚れを落とします。</p>
                </td>
              </tr>
              <tr>
                <td class="bdb-solid-gray1 fs14 pt8 pl4 pb8 pr4 va-top"><img src="/lib/images/ic_carwash_3.svg" width="48"></td>
                <td class="bdb-solid-gray1 fs14 pt8 pb8 pr4">
                  <p class="font-weight-bold">ワックス洗車</p>
                  <p>洗車の後、油系の被膜で全体をコーティングする洗車メニューです。水汚れを弾くことができます。ワックスの効果は通常1週間〜2週間ほど持続します。</p>
                </td>
              </tr>
              <tr>
                <td class="bdb-solid-gray1 fs14 pt8 pl4 pb8 pr4 va-top"><img src="/lib/images/ic_carwash_4.svg" width="48"></td>
                <td class="bdb-solid-gray1 fs14 pt8 pb8 pr4">
                  <p class="font-weight-bold">撥水洗車</p>
                  <p>洗車の後、シリコーン樹脂系のコーティング剤で仕上げます。撥水性が高く効果も3週間〜4週間と長持ちします。</p>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

      </article>
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    // [eventTrack]
    this.nativePVset('ABOUT_CARWASH_COURSE')
  },
  components: {
  }
}
</script>
